/**
 * The rail's contents.
 *
 * Same shape the design's own menu used -- a flat list of `group` and `item`
 * entries, rendered into sections by Rail.jsx -- so role filtering and the
 * grouping logic are unchanged. The ERP had nineteen departments here;
 * MySuhbat administers one thing, and this list is meant to stay short.
 *
 * The split is by what you can do with a page, not by what it holds: Kuzatuv
 * is what you watch and cannot change from here, Reyestr is what this panel
 * administers.
 *
 * Every entry is `roles: ["all"]` for now. The panel is staff-only -- the
 * server refuses anyone else before a page renders -- so there is nothing yet
 * for the rail to hide. Narrow these when a second staff role exists, not
 * before: a menu that hides things from everybody is just a menu.
 */
export const sidebarMenu = [
  { type: "group", label: "Kuzatuv", roles: ["all"] },
  { type: "item", label: "Umumiy koʻrinish", to: "/", end: true, icon: "solar:widget-5-outline", roles: ["all"] },
  { type: "item", label: "Muhokamalar", to: "/muhokamalar", icon: "solar:chat-round-line-outline", roles: ["all"] },
  // P2P chats from the MySuhbat app. Staff only on the server; this panel is staff-only anyway.
  { type: "item", label: "Shaxsiy suhbatlar", to: "/shaxsiy-suhbatlar", icon: "solar:chat-round-dots-outline", roles: ["staff"] },

  { type: "group", label: "Reyestr", roles: ["all"] },
  { type: "item", label: "Mijoz tizimlari", to: "/mijoz-tizimlari", icon: "solar:server-square-outline", roles: ["all"] },
  { type: "item", label: "Shaxslar", to: "/shaxslar", icon: "solar:users-group-rounded-outline", roles: ["all"] },
];

/**
 * Panel and cabinet accounts, as icon buttons in the top bar (2026-10-22).
 *
 * Who may open this panel or a cabinet is not part of the register a client
 * cares about, and it is visited rarely, so it left the rail for the bar --
 * one click away from anywhere, without a section of its own in the menu.
 * `group` names them in the bar's "where am I" line.
 */
export const topbarLinks = [
  { label: "Panel foydalanuvchilari", to: "/foydalanuvchilar/panel", icon: "solar:user-id-outline", group: "Tizim", roles: ["staff"] },
  { label: "Kabinet foydalanuvchilari", to: "/foydalanuvchilar/kabinet", icon: "solar:users-group-two-rounded-outline", group: "Tizim", roles: ["staff"] },
];
